import { render } from "./ProgramTagItemEditPane.vue?vue&type=template&id=255171c2&scoped=true&ts=true"
import script from "./ProgramTagItemEditPane.vue?vue&type=script&lang=ts"
export * from "./ProgramTagItemEditPane.vue?vue&type=script&lang=ts"

import "./ProgramTagItemEditPane.vue?vue&type=style&index=0&id=255171c2&scoped=true&lang=css"

import exportComponent from "D:\\ventla-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-255171c2"]])

export default __exports__